export { PlanHuntBasicsStep as BasicsStep } from '@wehunt/ui'
import { isEndBeforeStart, type PlanHuntBasicsState } from '@wehunt/ui'

export type BasicsState = PlanHuntBasicsState

/**
 * Schedule validity for the Basics step, independent of team/name:
 *   - start date + start time are required,
 *   - the start date can't be in the past,
 *   - the end is optional, but if provided it must be strictly after the start.
 * This gates "Continue" so a hunt can't be created without a start.
 */
export function hasValidSchedule(s: BasicsState): boolean {
  if (!s.startDate || !s.startTime) return false
  const today = new Date(); today.setHours(0, 0, 0, 0)
  if (new Date(`${s.startDate}T00:00:00`) < today) return false
  // isEndBeforeStart is false when the end is empty (open-ended is allowed) and
  // true only when a complete end is not strictly after the start.
  if (isEndBeforeStart(s)) return false
  return true
}

export function validateBasics(s: BasicsState): boolean {
  if (!s.groupId) return false
  if (s.huntName.trim().length === 0 || s.huntName.length > 120) return false
  return hasValidSchedule(s)
}
